import React from "react";
import { Box } from "@mui/material";
import { formatDateTime } from "utils/formatters";
import DataTable from "../../../components/common/tables/DataTable";
import SectionCard from "../components/SectionCard";
import StatusChip from "../components/StatusChip";

const actionLabels = {
  SUBMIT: "Gửi phê duyệt",
  RESUBMIT: "Gửi lại phê duyệt",
  EDIT: "Chỉnh sửa hồ sơ",
  APPROVE: "Phê duyệt",
  REQUEST_CHANGE: "Yêu cầu chỉnh sửa",
};

const approvalActionCell = ({ cell }) => actionLabels[cell.getValue()] || cell.getValue() || "-";
const actorCell = ({ row }) => row.original.changedByName || `Người dùng #${row.original.changedBy}`;
const timeCell = ({ cell }) => formatDateTime(cell.getValue());
const statusCell = ({ cell }) => <StatusChip value={cell.getValue()} />;

export default function HistoryTab({
  history = { contract: [], status: [], items: [], approvals: [], acceptanceApprovals: [] },
}) {
  const contractColumns = [
    { accessorKey: "action", header: "Hành động" },
    { accessorKey: "field", header: "Nội dung" },
    { accessorKey: "oldValue", header: "Giá trị cũ" },
    { accessorKey: "newValue", header: "Giá trị mới" },
    { accessorKey: "changedBy", header: "Người thực hiện" },
    { accessorKey: "changedAt", header: "Thời gian" },
    { accessorKey: "reason", header: "Lý do" },
  ];
  const statusColumns = [
    { accessorKey: "oldStatus", header: "Trạng thái cũ", Cell: statusCell },
    { accessorKey: "newStatus", header: "Trạng thái mới", Cell: statusCell },
    { accessorKey: "changedBy", header: "Người thực hiện" },
    { accessorKey: "changedAt", header: "Thời gian" },
    { accessorKey: "reason", header: "Lý do" },
  ];
  const itemColumns = [
    { accessorKey: "itemCode", header: "STT" },
    { accessorKey: "action", header: "Hành động" },
    { accessorKey: "oldValue", header: "Giá trị cũ" },
    { accessorKey: "newValue", header: "Giá trị mới" },
    { accessorKey: "changedBy", header: "Người thực hiện" },
    { accessorKey: "changedAt", header: "Thời gian" },
  ];
  const approvalColumns = [
    { accessorKey: "approvalProfileId", header: "Hồ sơ", Cell: ({ cell }) => `#${cell.getValue()}` },
    { accessorKey: "action", header: "Hành động", Cell: approvalActionCell },
    { accessorKey: "oldStatus", header: "Trạng thái cũ", Cell: statusCell },
    { accessorKey: "newStatus", header: "Trạng thái mới", Cell: statusCell },
    { accessorKey: "changedByName", header: "Người thực hiện", Cell: actorCell },
    { accessorKey: "changedAt", header: "Thời gian", Cell: timeCell },
    { accessorKey: "comment", header: "Ý kiến" },
  ];
  const acceptanceApprovalColumns = [
    { accessorKey: "acceptanceApprovalProfileId", header: "Hồ sơ", Cell: ({ cell }) => `#${cell.getValue()}` },
    { accessorKey: "action", header: "Hành động", Cell: approvalActionCell },
    { accessorKey: "oldStatus", header: "Trạng thái cũ", Cell: statusCell },
    { accessorKey: "newStatus", header: "Trạng thái mới", Cell: statusCell },
    { accessorKey: "changedByName", header: "Người thực hiện", Cell: actorCell },
    { accessorKey: "changedAt", header: "Thời gian", Cell: timeCell },
    { accessorKey: "comment", header: "Ý kiến" },
  ];

  return (
    <Box className="subcontract-stack">
      <SectionCard title="Lịch sử phê duyệt quyết định giao khoán"><DataTable columns={approvalColumns} data={history.approvals || []} /></SectionCard>
      <SectionCard title="Lịch sử phê duyệt nghiệm thu"><DataTable columns={acceptanceApprovalColumns} data={history.acceptanceApprovals || []} /></SectionCard>
      <SectionCard title="Lịch sử quyết định giao khoán"><DataTable columns={contractColumns} data={history.contract || []} /></SectionCard>
      <SectionCard title="Lịch sử trạng thái quyết định giao khoán"><DataTable columns={statusColumns} data={history.status || []} /></SectionCard>
      <SectionCard title="Lịch sử hạng mục quyết định giao khoán"><DataTable columns={itemColumns} data={history.items || []} /></SectionCard>
    </Box>
  );
}
